import { api } from "@/core/api/";

const apiUrl = "api/therapy";

export default {
    getTherapyEspecialist(properties) {
        return api.get("api/therapy/specialist", {
            params: {
                ...properties
            }
        });
    },
    getTherapyMonth(properties) {
        return api.get("api/therapy/month", {
            params: {
                ...properties
            }
        });
    },
    getBillingStatuses(properties) {
        return api.get("api/therapy/billingstatuses", {
            params: {
                ...properties
            }
        });
    },
    getAdmissionEmployeesByAcademicYear(properties) {
        return api.get("api/therapy/employees", {
            params: {
                ...properties
            }
        });
    },

    getAdjustmentReasons(validForUmesr) {
        return api.get(`${apiUrl}/adjustmentreasons?validForUmesr=${validForUmesr}`); 
    },
    getDisbursementAcademicYears() {
        return api.get("api/therapy/disbursementacademicyears");
    },
    getTapDisbursementRequestStudentEligibility() {
        return api.get("api/therapy/tapdisbursementrequeststudenteligibility");
    },
    getTapDisbursementRequestStudentEligibilityApproved() {
        return api.get("api/therapy/tapdisbursementrequeststudenteligibilityapproved");
    },
}
